/*
 * Copyright © 2018-2024, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React, { useEffect } from "react";
import { Loader } from "../../components/Loader";
import { useClinic } from "../../contexts/ClinicContext";
import { PageProps } from "../../models/PageProps";
import WorkerInvoices from "../Accounting/WorkerInvoices";
import AlertBox from "../../components/AlertBox";
import Clinics from "../Main/Onboarding/ClinicSide/Clinics";

function ClinicInvoices({ setPageLoading }: PageProps) {
  const { clinic, clinics, fetchClinicError } = useClinic();

  useEffect(() => {
    setPageLoading(false);
  }, [setPageLoading]);

  if (fetchClinicError) {
    return (
      <main className={clinic ? "main-signed-in" : "main-signed-in-no-clinic"}>
        <section>
          <AlertBox className="m-5" message={fetchClinicError} />
        </section>
      </main>
    );
  }

  if (clinic) {
    return (
      <main className="main-signed-in" id="settings-tabs">
        <section>
          <div className="px-4 lg:px-6 py-6">
            <WorkerInvoices clinic={clinic} />
          </div>
        </section>
      </main>
    );
  }

  return <Clinics myClinics={clinics} />;
}

export default Loader(ClinicInvoices);
